import type { RouteRecordRaw } from 'vue-router'

import LoginView from '@/modules/auth/views/LoginView.vue'
import RegisterView from '@/modules/auth/views/RegisterView.vue'
import ForgotPasswordView from '@/modules/auth/views/ForgotPasswordView.vue'
import ResetPasswordView from '@/modules/auth/views/ResetPasswordView.vue'
import VerifyEmailView from '@/modules/auth/views/VerifyEmailView.vue'

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      title: 'Вход в систему',
      requiresGuest: true,
    },
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    meta: {
      title: 'Регистрация',
      requiresGuest: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPasswordView,
    meta: {
      title: 'Восстановление пароля',
      requiresGuest: true,
    },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPasswordView,
    meta: {
      title: 'Новый пароль',
    },
  },
  {
    path: '/verify-email',
    name: 'verify-email',
    component: VerifyEmailView,
    meta: {
      title: 'Подтверждение email',
    },
  },
]
